<template>
    
    <div class="main-container">
        <div v-if="mobileVersion && completeLoad" class="btn-show-tree">
            <span>Selecciona la unidad:</span> 
            <button @click.stop="showMobileTree = true"><span>{{course.name}}</span><i class="material-icons">list</i></button>
        </div>
        <Modal v-if="completeLoad" @close="closeModal" :isOpen="modalIsOpened && !modalChangePassword">
            <div class="modal__content">
                <h3 class="modal__title">Te damos la bienvenida</h3>
                <div style="width: 100%;"><div style="position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;"><iframe frameborder="0" width="1200" height="675" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" :src="course.tutorial" type="text/html" allowscriptaccess="always" allowfullscreen="true" scrolling="no" allownetworking="all"></iframe> </div> </div>

            </div>
        </Modal>

        <div class="course__container">

            <div class="course__tree" :class="{'mobile':mobileVersion}" v-if="mobileVersion ? completeLoad && showMobileTree : completeLoad" >
                <div class="course__units-list" >
                    <template v-if="mobileVersion"> 
                        <VisibleModal />
                        <div class="back" @click.stop="showMobileTree = false"><i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>
                    </template>
                    <div class="tree__title" @click.stop="router.push(`/course/${route.params.courseId}`)">
                        <i class="material-icons-outlined">chrome_reader_mode</i>
                        <span>{{$t('course.tree.COURSE_CONTENT')}}</span>
                    </div>
    
                    <template v-for="(unit,index) in course.units" :key="index">
    
                        <div class="unit" :class="{'unit--selected':unit.modules.some(el=>el.id==route.params.moduleId)}">
                            <div class="unit__name" @click.stop="unit.expand ? unit.expand = false : unit.expand = true">
                                <span><strong>U{{unit.orderNumber}}:</strong> {{unit.name}}</span>
                                <i class="material-icons" v-if="!unit.expand">keyboard_arrow_down</i>
                                <i class="material-icons" v-else>keyboard_arrow_up</i>
                            </div>
                            
                            <div v-if="unit.expand" class="unit__modules-list">
                                <div v-for="(module,index) in unit.modules" :key="index"
                                @click.stop="route.query.t !== 'OD' ? router.push(`/course/${course.id}/module/${module.id}`) : '';showMobileTree = false;" 
                                class="unit__modules-list__module"
                                :class="{'unit__modules-list__module--selected':module.id == route.params.moduleId, 'disabled':route.query.t === 'OD'}">
                                    <span class="module__name" :class="{'module__name--completed': module.isCompleted}" >{{module.name}}</span> 
                                    <span class="module__status" v-if="!module.enabled && !module.isCompleted">{{ $t('module.status.COMING_SOON') }}</span>
                                    <span class="module__status" v-else-if="module.enabled && !module.isCompleted && module.hasStarted">{{ $t('module.status.IN_PROGRESS') }}</span>
                                    <span class="module__status" v-else-if="module.enabled && !module.isCompleted && !module.hasStarted">{{ $t('module.status.AVAILABLE') }}</span>
                                    <i class="material-icons green" style="color: #0009696" v-else-if="module.isCompleted">check_circle</i>
                                </div>
                            </div>
                        </div>
    
                    </template>
                </div><!-- /course__units-list -->

                <div class="course__tree--div" v-if="course.NeedFinalPracticeToCertificate && course.courseType != 'ON_DEMAND'"
                    :class="{'clicked': clickedDiv === 'finalPractice'}" @click.stop="router.push(`/course/${route.params.courseId}/finalPractice`); showMobileTree = false; clickedDiv = 'finalPractice'">
                    <div class="tree__title">
                        <i class="material-icons-outlined">where_to_vote</i>
                        <span>{{ $t('course.tree.PRACTICE') }}</span>
                    </div>
                </div>
                <!--<div class="course__tree--div" v-if="course.courseType != 'ON_DEMAND'"
                    :class="{'clicked': clickedDiv === 'board'}" @click.stop="router.push(`/course/${route.params.courseId}/board`); showMobileTree = false; clickedDiv = 'board'">
                    <div class="tree__title">
                        <i class="material-icons-outlined">groups</i>
                        <span>{{ $t('course.tree.BOARD') }}</span>
                    </div>
                </div>-->
                <div
                v-if="user?.permissions?.includes('INTERACCION_VISUALIZACION')"
                class="course__tree--div" :class="{'clicked': clickedDiv === 'studentsLog', 'disabled':route.query.t === 'OD'}" @click.stop="route.query.t !== 'OD' ? router.push(`/course/${route.params.courseId}/studentsActivityLog`) : ''; route.query.t !== 'OD' ? showMobileTree = false : ''; route.query.t !== 'OD' ? clickedDiv = 'studentsLog' : ''">
                    <div class="tree__title">
                        <i class="material-icons-outlined">text_snippet</i>
                        <span>{{ $t('course.tree.STUDENTSLOG') }}</span>
                    </div>
                </div>
                <div class="course__tree--div" @click.stop="route.query.t !== 'OD' ? openModal() : '';"
                :class="{'disabled':route.query.t === 'OD'}"
                >
                    <div class="tree__title">
                        <i class="material-icons-outlined">help_outline</i>
                        <span>{{ $t('course.tree.TUTORIAL') }}</span>
                    </div>
                </div>
                <div class="course__tree--div ">
                    <span class="course__code" >{{course.code}}</span>
                </div>
            </div> <!-- course__tree -->

            <!-- Skeletor -->
            <div v-if="!mobileVersion && !completeLoad" class="course__tree">
                <div class="course__units-list">
                    <div class="unit__course-name">
                        <span class="material-icons"><Skeletor width="100%" height="18px" /> </span>
                        <span><Skeletor width="100%" height="18px" /></span>
                    </div>
                    <!-- <div class="unit">
                        <span class="unit__name"><Skeletor width="100%" height="12px"/></span>
                        <span class="unit__name"><Skeletor width="100%" height="12px" style="margin-top:4px"/></span>
                    </div> -->
                    
                    <div class="unit" v-for="index in 3" :key="index" >
                        <div class="unit__name">
                            <span><Skeletor width="100%" height="12px"/></span>
                            <i class="material-icons">keyboard_arrow_down</i>
                        </div>                 
                    </div>
                </div> 
            </div> <!-- /Skeletor -->

            <div class="course__content">
                <template v-if="completeLoad">

                    <div v-if="!route.name.includes('COURSE_')" class="course__content__intro">
                        <div class="back-route" v-if="route.query.t !== 'OD'" @click.stop="router.push('/my-courses')"><i class="material-icons">keyboard_arrow_left</i><span>{{ $t('course.actions.RETURN') }}</span></div>
                        <div class="course__content__intro__header">
                            <div class="course__content__intro__header--info">
                                <span>{{ $t('course.intro.TITLE')}}</span>
                                <div v-if="!course.endDate == null" style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
                                    <div v-if="course.status != 'InProgress'" class="pill">{{$t(`course.status.${course.status}`)}}</div>
                                    <span>{{ course.status.toLowerCase() === 'finished' ? $t('course.intro.ENDED') : $t('course.intro.END_DATE') }} {{formatDate(course.endDate)}}</span>
                                </div>
                            </div>
                            <h2 class="course__content__intro__header--name">{{course.name}}</h2>
                        </div>
                        <div class="course__content__intro__image" :style="{'background-image': `url(${course.image})`}"></div>


                        <!-- only if t=OD -->
                        <div class="course__content__intro__start-button" v-if="route.query.t === 'OD'">
                            <button v-if="course.isOpen" @click.stop="modalInscriptionIsOpened = true">{{ $t('course.actions.START') }}<i class="material-icons">east</i></button>
                        </div>
                        
                        
                        <Modal :isOpen="modalInscriptionIsOpened" @close="modalInscriptionIsOpened = false">
                            <div class="modal-content-container">
                                <Preinscription :coursePreinscriptionId="course.preinscriptionId" @submissionResult="handleSubmissionResult"/>
                            </div>
                        </Modal>


                        <!-- modal "se le envio un mail" -->
                         <Modal :isOpen="modalEmailSent" @close="modalEmailSent = false">
                            <div class="modal-text-content modal-email-sent">
                                <div class="modal-email-sent__content">
                                    <i class="material-icons">email</i>
                                    <h3 class="modal__title">¡Listo!</h3>
                                    <p>Te hemos enviado un correo <br/>
                                        con las instrucciones para completar tu inscripción.</p>
                                    <p><small>Si no aparece en la bandeja de entrada, verifica tu carpeta de spam.</small></p>
                                    <button @click.stop="modalEmailSent = false" class="btn-entendido">Entendido</button>
                                </div>
                            </div>
                        </Modal>


                        <div class="modal-change-password">
                            <!-- modal "cambiar contraseña" -->
                            <Modal :isOpen="modalChangePassword" :closeButton="false">
                                <div class="modal-text-content">
                                    <!-- <div class="modal-text-content__content">
                                        <i class="material-icons">vpn_key</i>
                                        <h3 class="modal__title">Cambiar contraseña</h3>
                                        <p>Ingresa tu nueva contraseña</p>
                                        <Input type="password" placeholder="Nueva contraseña" />
                                        <button @click.stop="changePassword()" class="btn-change-password">Cambiar contraseña</button>
                                    </div> -->
                                    <div class="modal-change-password__content">
                                        <img src="@\assets\logo-fundacion-forge.png" alt="" class="modal-change-password__content__logo">
                                        <h3 class="modal__title">Crea una contraseña</h3>
                                        <p>Esto es necesario para guardar tu progreso y mejorar tu experiencia.</p>


                                        <div class="modal-change-password__content__fields">

                                            <!-- <Input placeholder="Email" v-model="userData.email" label="Email" disabled="true" /> -->
    

                                            <div class="login-error" v-if="v$.passwordConfirm.sameAsPassword.$invalid && !v$.passwordConfirm.required.$invalid && !v$.password.required.$invalid && !invalidPassword">
                                                <i class='material-icons'>error_outline</i>{{v$.passwordConfirm.sameAsPassword.$message}} 
                                            </div>
                                            <!-- <div class="password-error" v-if="(v$.passwordConfirm.$dirty && v$.passwordConfirm.sameAsPassword.$invalid) && !v$.passwordConfirm.required.$invalid && !v$.password.required.$invalid && !invalidPassword">
                                                <i class='material-icons'>error_outline</i>{{v$.passwordConfirm.sameAsPassword.$message}} 
                                            </div> -->
                                            <!-- <div class="password-error" v-if="invalidPassword && !v$.password.required.$invalid">
                                                <i class='material-icons'>error_outline</i>La contraseña no cumple los requisitos
                                            </div> -->
    
    
        
                                            <Input
                                            type="password"
                                            placeholder="Nueva contraseña"
                                            label="Nueva contraseña" v-model="password"
                                            :isError="(v$.password.$dirty && v$.password.$invalid) || invalidPassword"
                                            @input="invalidPassword = !validatePassword()"
                                            />
    
                                            <Input
                                            type="password"
                                            placeholder="Confirmar contraseña"
                                            label="Confirmar contraseña"
                                            v-model="passwordConfirm"
                                            :isError="(v$.passwordConfirm.$dirty && v$.passwordConfirm.$invalid) || invalidPassword"
                                            @input="invalidPassword = !validatePassword()"
                                            />

                                            <div class="modal-change-password__content__instruction"
                                                :class="{'modal-change-password__content__instruction--red': (v$.password.$dirty && v$.password.required.$invalid) || invalidPassword}">
                                                La contraseña debe contener como mínimo 6 caracteres, incluyendo al menos 1 mayúscula y 1 número.
                                            </div>
    
    
                                            <button @click="changePassword()" class="btn-change-password" :disabled="awaitRequest || v$.$invalid || (invalidPassword && !v$.password.required.$invalid)">{{ awaitRequest  ? 'Procesando' : 'Crear contraseña' }}<i class="material-icons">arrow_forward</i></button>    
    
    
                                            <!-- boton omitir por ahora -->
    
                                            <!-- <button @click="modalChangePassword = false" class="btn-skip">Omitir por ahora</button> -->

                                        </div>    

                                        <p class="modal-change-password__content__terms">
                                            <!-- Haciendo click en “Crear contraseña” aceptas los Términos y Condiciones y las Políticas de Privacidad de Forge Foundation -->
                                            Haciendo click en “Continuar” aceptas los <a :href="`/terms.pdf?v=${linkRandParam}`" target="_blank">Términos y Condiciones y las Políticas de Privacidad</a> de Forge Foundation
                                        </p>

                                        
                                    </div>
                                </div>
                            </Modal>
                        </div>

                        <!-- <div class="decription">{{course.description}}</div> -->

                        <template v-if="(user?.role?.toLowerCase() === 'learninguser')">




                            <template v-if="course.canCertificate || course.courseType === 'ON_DEMAND' && !goToModule && course?.userStatus?.toLowerCase() === 'finished'">
                                <div class="course-finished">
                                    <div><i class="material-icons">school</i></div>
                                    <div>
                                        <div class="course-finished__title">¡Felicitaciones! Completaste todas las unidades. </div>
                                        <div class="course-finished__info">Recuerda que puedes seguir accediendo a los materiales del curso todas las veces que necesites.</div>
                                    </div>
                                </div>
                                <button v-if="course.courseType !== 'ON_DEMAND'" @click.stop="!certificateLoaded && downloadCertificate()" class="btn-download-certificate" :class="certificateLoaded && 'loading' || ''">
                                    <span v-if="!certificateLoaded" >Descargar certificado</span>
                                    <span v-else class="spinner"></span>
                                </button>
                            </template>


                            <button v-else-if="!course.canCertificate && !course.courseIsFinished && route.query.t !== 'OD'" 
                                class="button-continue" :disabled="!course.goToModule"
                                @click.stop="router.push(`/course/${course.id}/module/${course.goToModule}`)">
                                {{!course.userStatus ? $t('course.actions.START_COURSE') : $t('course.actions.CONTINUE_COURSE')}}<i class="material-icons">east</i>
                            </button> 


                            <Modal :isOpen="modalStudentsQty" :closeButton="false">
                                <div class="modal-text-content">
                                    <div class="modal-text-content__content">

                                        <h3 class="modal__title">Cantidad de jóvenes con quienes aplicaste lo aprendido en el curso</h3>
                                        <div class="modal__info">Por favor, ingresa la cantidad de jóvenes con quienes estimas haber aplicado lo aprendido en el curso.</div>
                                        <Input
                                            v-model="TotalStudentsQty"
                                            type="number"
                                            placeholder="Cantidad de jóvenes"
                                            label="Cantidad de jóvenes"
                                        />
                                        <div class="buttons">
                                            <button class="confirm" :disabled="loadingModalStudentsQty || !TotalStudentsQty" @click.stop="submitTotalStudentsQty()">{{ $t('global.CONFIRM') }}</button>

                                        </div>
                                    </div>
                                </div>
                            </Modal>

                            <!-- <template v-if="course.userFinishedStatus == 'INCOMPLETED' && course.courseIsFinished">
                                <div class="course-finished">
                                    <div><i class="material-icons">school</i></div>
                                    <div>
                                        <div class="course-finished__title">Llegaste al final del curso.</div>
                                        <div class="course-finished__info">Recuerda que puedes seguir accediendo a los materiales del curso todas las veces que necesites.</div>
                                    </div>
                                </div>
                                <button class="btn-download-certificate" @click.stop="downloadCertificate()">Descargar constancia de cursada</button>
                            </template> -->

                            <!-- canCertificate == false && courseIsFinished == true -->
                            <div class="course-finished course-finished--red" v-if="!course.canCertificate && course.courseIsFinished == true">
                                <div><i class="material-icons">error</i></div>
                                <div>
                                    <div class="course-finished__title">El curso ha finalizado.</div>
                                    <div class="course-finished__info">Recuerda que puedes seguir accediendo a los materiales del curso aunque ya no es posible entregar actividades ni participar de los foros.</div>
                                </div>
                            </div>

                        </template>


                        <!-- if isOpen false  -->
                        <EmptyState
                            v-if="!course.isOpen && !course.userStatus && !course.canCertificate && !course.courseIsFinished"
                            icon="lock"
                            title="Curso cerrado"
                            message="El curso ha finalizado y no es posible inscribirse."
                            color="pink"
                        />


                        <div class="course__content__intro__tabs">
                            <div class="course__content__intro__tabs__header">
                                <div class="course__content__intro__tabs__header__tab" @click.stop="clickedTab = 'about'">
                                    <span>{{ $t('course.intro.ABOUT') }}</span>
                                    <div class="course__content__intro__tabs__header__tab__line" :class="{'course__content__intro__tabs__header__tab__line--selected': clickedTab === 'about'}"></div>
                                </div>
                                <div class="course__content__intro__tabs__header__tab" v-if="course.courseType == 'ON_DEMAND'" @click.stop="clickedTab = 'reviews'">
                                    <span>{{ $t('course.intro.REVIEWS') }}</span>
                                    <div class="course__content__intro__tabs__header__tab__line" :class="{'course__content__intro__tabs__header__tab__line--selected': clickedTab === 'reviews'}"></div>
                                </div>
                            </div>
                            <div class="course__content__intro__tabs__body">
                                <div v-if="clickedTab === 'about'" class="course__content__intro__tabs__body__about">
                                    <div class="quantities" v-if="course.courseType !== 'ON_DEMAND'">
                                        <div>
                                            <i class="material-icons">book</i><span>{{course.unitsQuantity}} {{ $t('course.intro.UNITS') }}</span>
                                        </div> 
                                        <div>
                                            <i class="material-icons">format_list_bulleted</i><span>{{course.modulesQuantity}} {{$t('course.intro.MODULES')}}</span>
                                        </div> 
                                    </div>
                                    <div class="course__content__intro__tabs__body__about__description-title"><h4>{{ $t('course.intro.descriptionTitle') }}</h4></div>
                                    <div class="course__content__intro__tabs__body__about__description">{{course.description}}</div>
                                    <div class="course__content__intro__tabs__body__about__characteristics-title"><h4>{{ $t('course.intro.courseCharacteristicsTitle') }}</h4></div>
                                    <div class="course__content__intro__tabs__body__about__characteristics">
                                        <div class="course__content__intro__tabs__body__about__characteristics__item">
                                            <i class="material-icons">devices</i>
                                            <span>{{ $t('course.intro.modality') }} {{ course.modality }}</span>
                                        </div>
                                        <!-- <div class="course__content__intro__tabs__body__about__characteristics__item">
                                            <i class="material-icons">schedule</i>
                                            <span>{{ $t('course.intro.duration') }}: {{course.durationInHours}} {{ course.durationInHours == 1 ? 'hora' : 'horas' }}</span>
                                        </div> -->
                                        <div class="course__content__intro__tabs__body__about__characteristics__item">
                                            <i class="material-icons">school</i>
                                            <span>{{ $t('course.intro.certification') }}</span>
                                        </div>
                                        <div class="course__content__intro__tabs__body__about__characteristics__item" v-if="!course.needFinalPractiseToCertificate">
                                            <i class="material-icons">dvr</i>
                                            <span>{{ $t('course.intro.certificationActivity') }}</span>
                                        </div>
                                    </div>
                                    <h4>¿Qué vas a necesitar para hacer este curso?</h4>
                                    <div class="course__content__intro__tabs__body__about__description">Para realizar este curso no necesitarás conocimientos previos pero sí, curiosidad y apertura para reflexionar y cuestionarte.</div>
                                </div>

                                <div v-else-if="clickedTab === 'reviews'" class="course__content__intro__tabs__body__reviews">
                                    <div class="rating">
                                        <h4>Valoraciones</h4>
                                        <div class="rating__container" v-if="ratingData.header.total">
                                            <div class="rating__total">
                                                <strong>{{ ratingData.header.total }}</strong>
                                                <RatingStars 
                                                    :rating="ratingData.header.total"
                                                />
                                                <span>Rating del curso</span>
                                            </div>
                                            <div class="rating__detail">
                                                <div v-for="detail in ratingData.header.detail" :key="detail.star">
                                                    <div class="rating__detail__bar">
                                                        <div :style="{width: `${detail.percentage}%`}"></div>
                                                    </div>
                                                    <RatingStars 
                                                        :rating="detail.star"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <EmptyState v-else icon="error" title="Este curso aún no tiene valoraciones." color="pink" />
                                    </div>
                                    <!-- <div class="comments">
                                        <h4>Comentarios del curso</h4>
                                        <template v-if="ratingData.comments">
                                            <div class="comments__container" v-if="ratingData.comments.data.length">
                                                <div v-for="comment in ratingData.comments.data" :key="comment.id" class="comment">
                                                    <div class="comment__picture">
                                                        <img :src="getFile(comment.picture,'user')" v-if="comment.picture">
                                                        <template v-else>{{ comment.firstName?.charAt(0) + comment.lastName?.charAt(0) }}</template>
                                                    </div>
                                                    <div class="comment__content">
                                                        <strong>{{ `${comment.firstName || 'Usuario'} ${comment.lastName || 'anónimo'}` }}</strong>
                                                        <RatingStars 
                                                            :rating="comment.stars"
                                                        />
                                                        <span v-if="comment.comment">{{ comment.comment }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="comments__empty">Este curso aún no tiene comentarios.</div>
                                            <div class="pagination" v-if="ratingData.comments.totalResults > pagination.rows">
                                                <button class="prev-next" @click.stop="selectPage('prev')" :disabled="pagination.page == 0"><i class="material-icons">arrow_back</i><span>Anterior</span> </button>
                                                <div class="page"><span>{{ pagination.page+1 }} / </span>{{ pagination.pages }}</div>
                                                <button class="prev-next" @click.stop="selectPage('next')" :disabled="pagination.page+1 == pagination.pages"><span>Siguiente</span> <i class="material-icons">arrow_forward</i></button>
                                            </div>
                                            
                                        </template>
                                        <Loader v-else/>

                                    </div> -->
                                </div>

                            </div>

                        </div>
                        

                        <div v-if="user?.permissions?.includes('CURSO_REPORTES')" class="tutor-report--container">
                            <button  class="tutor-report" @click.stop="router.push(`/course/${course.id}/report`)">Ver reporte</button>
                        </div>

                    </div>

                    <template v-if="route.params.courseId">
                        <router-view />
                    </template>

                </template>

                <!-- Skeletor -->                
                <div v-else class="course__content__intro">
                    <div class="back-route"><i class="material-icons"><Skeletor width="10px" height="12px"/></i><span><Skeletor width="60px" height="12px" style="margin-left:4px"/></span></div>
                    <div class="course__content__intro__header">
                        <div class="course__content__intro__header--name">
                            <span><Skeletor width="200px" height="13px"/></span>
                            <h2><Skeletor width="300px" height="24px" style="margin-top:13px"/></h2>
                        </div>
                        <div class="course__content__intro__header--info">
                            <span><Skeletor width="100px" height="12px" style="margin-left:13px"/></span>
                        </div>
                    </div>
                    <div class="course__content__intro__image"><Skeletor width="100%" height="300px" style="border-radius:8px"/></div>
                    <div class="quantities">
                        <div>
                            <i class="material-icons"><Skeletor width="20px" height="16px"/></i><span><Skeletor width="70px" height="16px"/></span>
                        </div> 
                        <div>
                            <i class="material-icons"><Skeletor width="20px" height="16px"/></i><span><Skeletor width="80px" height="16px"/></span>
                        </div> 
                    </div>
                    <div class="decription"></div>
                </div>
                <!-- /Skeletor -->
            </div> <!-- /course__content -->

        </div><!-- /course__container -->
    </div><!-- /main-container -->
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { onMounted, ref, watch, computed } from 'vue';
import { inject, onBeforeUnmount } from "@vue/runtime-core";
import { Skeletor } from 'vue-skeletor';
import VisibleModal from '@/components/VisibleModal.vue';
import Modal from '../components/Modal.vue';
import { useI18n } from 'vue-i18n'
import Preinscription from './Inscription/Preinscription.vue';
import persistentData from '@/plugins/persistentData';
import Input from '../components/Input.vue';
import RatingStars from '@/components/RatingStars.vue';
// import Loader from '@/components/Loader.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers, sameAs } from '@vuelidate/validators';
import EmptyState from '@/components/EmptyState.vue';



export default {
    components: {
        Skeletor,
        VisibleModal,
        Modal,
        Preinscription,
        Input,
        EmptyState,
        RatingStars,
        // Loader
    },
    methods: {
        async handleSubmissionResult(response) {
            if (response.key) {
                try {
                    // Authenticate the student
                    let loginData = {
                        learningUserId: response.learningUserId,
                        signInKey: response.key
                    };

                    const request = await this.$store.dispatch('courses_newAuthenticate', loginData);

                    if (request.status === 200) {
                        persistentData.set('token', request.data.token);
                        persistentData.set('tokenExpiration', request.data.tokenExpiration);
                        persistentData.set('user', JSON.stringify(request.data));

                        // var customLinkId = parseInt(persistentData.get('customLinkId'));
                        // //modify to number
                        // if (customLinkId) {
                        //     customLinkId = parseInt(customLinkId);
                        // }
                        

                        this.$store.dispatch('manageUser_active');

                        this.$store.dispatch('notifications_create',{text: 'Inscripción exitosa. Redireccionando...'});

                        // Sign the student into the course
                        let studentData = {
                            courseId: this.course.id,
                            learningUserId: response.learningUserId,
                            signInKey: response.key,
                            // LinkId: customLinkId ? customLinkId : null
                        };

                        await this.$store.dispatch('courses_signStudentInCourse', studentData);

                        let url = location.href
                        let urlWithoutT = url.split('?')[0]
                        window.location.href = `${urlWithoutT}`

                        // do hasChangedPassword() here and add "?psw=0" to the url
                        this.hasChangedPassword();
                        // add "?psw=0" to the url
                        // this.$router.push({ query: { psw: 0 } });
                        window.location.href = `${urlWithoutT}?psw=0`

                        // customLinkId ? persistentData.remove('customLinkId') : '';

                    } else {
                        this.$store.dispatch('notifications_create',{text: 'Ocurrió un error. Por favor intenta nuevamente.'});         
                    }
                    
                } catch (error) {
                    // console.error('An error occurred during authentication or course sign-in:', error);
                    // alert('An error occurred. Please try again.');
                    console.error('Ocurrió un error durante la autenticación o el ingreso al curso:', error);
                    this.$store.dispatch('notifications_create',{text: 'Ocurrió un error. Por favor intenta nuevamente.'});
                }
            } else {
                if (response) {
                    this.modalInscriptionIsOpened = false;
                    this.modalEmailSent = true;
                    // alert('An email has been sent with further instructions.');
                } else {
                    // alert('An error occurred. Please try again.');
                    this.$store.dispatch('notifications_create',{text: 'Ocurrió un error. Por favor intenta nuevamente.'});
                }
            }
        }

    },
    setup() {
        const hidePractice = ref(false);
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const formatDate = inject('formatDate');
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        const mobileVersion = inject('mobileVersion')
        const course = ref();
        const completeLoad = ref(false);
        let refreshInterval = null;
        const showMobileTree = ref(false);
        const modalIsOpened = ref(null)
        const modalInscriptionIsOpened = ref(false)
        const { t } = useI18n()
        const certificateLoaded = ref(false)
        const clickedDiv = ref(null);
        const clickedTab = ref('about');
        // const inscriptionStatus = ref(null);
        const modalEmailSent = ref(false);
        const modalChangePassword = ref(false);
        const awaitRequest = ref(false);

        const ratingData = ref({
            header: null,
            comments: null
        });

        const v$ = useVuelidate();
        // const username = ref("");
        const password = ref("");
        const passwordConfirm = ref("");
        const invalidPassword = ref(false);

        const modalStudentsQty = ref(false);
        const loadingModalStudentsQty = ref(false);
        const TotalStudentsQty = ref(null);

        const userData = JSON.parse(persistentData.get('user'));


        const linkRandParam = Math.round(Math.random()*1000);


        function validatePassword() {
            let validPassword = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{6,32})$/); //eslint-disable-line
            // validPassword.test(password.value) ? invalidPassword.value = false : invalidPassword.value = true ;
            return validPassword.test(password.value);
        }



        watch(()=>route.params.moduleId,()=>{
            if(route.params.moduleId){
                course.value.units.forEach(unit =>{
                    unit.modules.some(mod=>mod.id==route.params.moduleId) ? unit.expand = true : '';
                })
            }
        })

        watch(()=>mobileVersion.value,()=>showMobileTree.value=false)

        const orderByOrderNumber = arr => arr.sort( (a,b) => a.orderNumber - b.orderNumber );

        async function getCourses(){
            try {
                let req = await store.dispatch('courses_courseTrees',route.params.courseId);
                course.value = req.data;
                orderByOrderNumber(course.value.units);
                course.value.units.forEach(unit => orderByOrderNumber(unit.modules));
                /* if(route.params.moduleId){
                    course.value.units.forEach(unit =>{
                        unit.modules.some(mod=>mod.id==route.params.moduleId) ? unit.expand = true : '';
                    })
                } */
                // course.value.units.push(course.value.units[2])
                completeLoad.value = true;
            } catch (error) {
               console.log(error)
               if(error.response.data == 'USER_ROLE_NOT_ALLOWED') router.push('/notAllowed');
               else store.dispatch('notifications_create',{text: t('course.errors.ERROR_LOADING')});              
            }
        }

        async function anonGetCourses() {
            try {
                let req = await store.dispatch('courses_anonCourseTrees',route.params.courseId);
                course.value = req.data;
                orderByOrderNumber(course.value.units);
                course.value.units.forEach(unit => orderByOrderNumber(unit.modules));
                completeLoad.value = true;
            } catch (error) {
                console.log(error)
                store.dispatch('notifications_create',{text: t('course.errors.ERROR_LOADING')});
            }
        }

        async function downloadCertificate() {
            certificateLoaded.value = true
            await store.dispatch('courses_certificates', route.params.courseId);
            certificateLoaded.value = false

            // ask for final practice students qty
            let studentsQtyModalVisibleData = await getStudentsQtyModalVisible();
            if (!studentsQtyModalVisibleData.isComplete) {
                modalStudentsQty.value = true;
            }
        }

        async function getRatingHeader(){
            try {
                let req = await store.dispatch('courses_ratingHeader', route.params.courseId);
                ratingData.value.header = req.data;
            } catch (error) {
                console.log(error)
                store.dispatch('notifications_create',{text: 'Error al obtener calificación del curso'});
            }
        }
        const pagination = ref({
            page: 0,
            rows: 2,
            pages: null,
            remainResults: null
        })

        // async function getRatingComments(){
        //     try {
        //         let req = await store.dispatch('courses_ratingComments', {courseId: route.params.courseId, page: pagination.value.page, rows: pagination.value.rows});
        //         ratingData.value.comments = req.data;
        //         pagination.value.remainResults = req.data.totalResults - (pagination.value.page * pagination.value.rows);
        //         pagination.value.pages = Math.ceil(req.data.totalResults / pagination.value.rows);
        //     } catch (error) {
        //         console.log(error)
        //         store.dispatch('notifications_create',{text: 'Error al obtener comentarios del curso'});
        //     }
        // }

        function selectPage(prevNext){
            ratingData.value.comments = null;
            if(prevNext == 'next') pagination.value.page++;
            else if(prevNext == 'prev') pagination.value.page--;
            // getRatingComments()
        }


        const closeModal = () => modalIsOpened.value = false
        const openModal = () => modalIsOpened.value = true


        // changePassword
        async function changePassword() {
            awaitRequest.value = true;
            try {
                let req = await store.dispatch('courses_changePassword', {password: password.value, passwordConfirm: passwordConfirm.value});
                if(req.status == 200){
                    store.dispatch('notifications_create',{text: 'Contraseña creada con éxito'});
                    modalChangePassword.value = false;
                }
            } catch (error) {
                console.log(error)
                store.dispatch('notifications_create',{text: 'Error al cambiar contraseña'});
            }
            awaitRequest.value = false;
        }

        async function hasChangedPassword() {
            let req = await store.dispatch('courses_hasChangedPassword');
            modalChangePassword.value = !req.data.hasChangedPassword;
            // modalChangePassword.value = req.data.hasChangedPassword;
        }


        async function getStudentsQtyModalVisible() {
            try {
                let req = await store.dispatch('activities_TotalStudentsQty', route.params.courseId);
                // TotalStudentsQty.value = req.data;
                return req.data;
            } catch (error) {
                console.log(error);
            }
        }

        async function submitTotalStudentsQty() {
            loadingModalStudentsQty.value = true;
            try {
                await store.dispatch('activities_TotalStudentsQtyUpdate', { courseId: route.params.courseId, qty: TotalStudentsQty.value });
                store.dispatch('notifications_create', { text: 'Cantidad de jóvenes con quienes aplicaste lo aprendido en el curso actualizada' });
                modalStudentsQty.value = false;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al actualizar la cantidad de jóvenes con quienes aplicaste lo aprendido en el curso' });
            }
            loadingModalStudentsQty.value = false;
        }

        onMounted(async()=>{
            // if url t=OD and has also query params key and learningUserId
            // example url: http://localhost:8080/course/83?t=OD&key=3fa85f64-5717-4562-b3fc-2c963f66afa6&learningUserId=3fa85f64-5717-4562-b3fc-2c963f66afa6
            getRatingHeader();
            // getRatingComments();
            if(route.query.t === 'OD' && route.query.key && route.query.learningUserId){
                try {
                    // Authenticate the student
                    let loginData = {
                        learningUserId: route.query.learningUserId,
                        signInKey: route.query.key
                    };

                    const request = await store.dispatch('courses_newAuthenticate', loginData);

                    if (request.status === 200) {
                        persistentData.set('token', request.data.token);
                        persistentData.set('tokenExpiration', request.data.tokenExpiration);
                        persistentData.set('user', JSON.stringify(request.data));

                        store.dispatch('manageUser_active');

                        store.dispatch('notifications_create',{text: 'Inscripción exitosa. Redireccionando...'});

                        // Sign the student into the course
                        let studentData = {
                            courseId: route.params.courseId,
                            learningUserId: route.query.learningUserId,
                            signInKey: route.query.key
                        };

                        await store.dispatch('courses_signStudentInCourse', studentData);

                        let url = location.href
                        let urlWithoutT = url.split('?')[0]
                        window.history.pushState({}, document.title, urlWithoutT)
                        window.location.href = `${urlWithoutT}?psw=0`
                        
                    } else {
                        store.dispatch('notifications_create',{text: 'Ocurrió un error. Por favor intenta nuevamente.'});         
                    }
                    
                } catch (error) {
                    // console.error('An error occurred during authentication or course sign-in:', error);
                    // alert('An error occurred. Please try again.');
                    console.error('Ocurrió un error durante la autenticación o el ingreso al curso:', error);
                    store.dispatch('notifications_create',{text: 'Ocurrió un error. Por favor intenta nuevamente.'});
                }
            }


            //if(route.query.psw === '0') modalChangePassword.value = true;
            //instead of showing modal by default, ask hasChangedPassword, if return false show modal, if true, do nothing
            if(route.query.psw === '0' && user.value.role.toLowerCase() === 'learninguser') {
                // if(hasChangedPassword()) modalChangePassword.value = true;
                hasChangedPassword();
            }
            
            if(route.query.t === 'OD') await anonGetCourses();
            else await getCourses();
            if(user.value.role.toLowerCase() === 'learninguser' && !course.value.userStatus && route.query.t !== 'OD'){
                modalIsOpened.value = true;
            }
            refreshInterval = setInterval(async()=>{
                let unitsExpanded = [];
                course.value.units.forEach(unit => {
                    if(unit.expand) unitsExpanded.push(unit.id)
                })
                await getCourses();
                course.value.units.forEach(unit => {
                    if(unitsExpanded.includes(unit.id)) unit.expand = true;
                })
            },120000);
            if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
                hidePractice.value = true;
            }

            // if route.path studentsActivityLog, clickedDiv = studentsLog
            if(route.path.includes('studentsActivityLog')) clickedDiv.value = 'studentsLog';
            if(route.path.includes('finalPractice')) clickedDiv.value = 'finalPractice';
            if(route.path.includes('board')) clickedDiv.value = 'board';
        });

        onBeforeUnmount(()=>clearInterval(refreshInterval));

        return{
            hidePractice,
            router,
            route,
            user,
            formatDate,
            getFile,
            mobileVersion,
            course,
            completeLoad,
            refreshInterval,
            showMobileTree,
            closeModal,
            modalIsOpened,
            modalInscriptionIsOpened,
            openModal,
            downloadCertificate,
            certificateLoaded,
            clickedDiv,
            clickedTab,
            // inscriptionStatus
            modalEmailSent,
            modalChangePassword,
            ratingData,
            pagination,
            selectPage,
            // username,
            password,
            passwordConfirm,
            v$,
            invalidPassword,
            validatePassword,
            changePassword,
            linkRandParam,
            userData,
            hasChangedPassword,
            modalStudentsQty,
            loadingModalStudentsQty,
            TotalStudentsQty,
            getStudentsQtyModalVisible,
            submitTotalStudentsQty
        }
    },
    validations () {
        return {
            // username: { 
            //     required: helpers.withMessage('Este campo es requerido', required),
            //     email: helpers.withMessage('El formato del mail es inválido', email)
            // },
            password: { 
                required: helpers.withMessage('Este campo es requerido', required)
            },
            passwordConfirm: {
                required: helpers.withMessage('Este campo es requerido', required),
                sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.password))
            },
            // activationCode: { 
            //     required: helpers.withMessage('Este campo es requerido', required)
            // },
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';
@import '~vue-skeletor/dist/vue-skeletor.css';

.disabled {
    opacity: 0.5;
    cursor: default!important;
    .tree__title {
        cursor: default!important;
    }
}

.back-route{
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

.module{
    &__name{
        &--completed{
            color: $green;
        }
    }
    &__status{
        font-weight: 600;
        font-style: italic;
        font-size: 11px;
    }
}

.main-container{
    background-color: #f5f5f5;
    min-height: calc(100vh - 56px);
}
.course{
    &__container{
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        background-color: #f5f5f5;
    }
    &__tree{
        min-width: 27%;
        height: fit-content;
        max-height: calc(100vh - 60px);
        margin-right: 8px;
        position:sticky;
        top: 68px;
        flex-direction: column;
        gap: 26px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(0,0,0,.1);
            margin-top: 4px;
        }
        &::-webkit-scrollbar {
            width: 8px;
            height: 14px;
            background-color: transparent;
            margin: 4px 0;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }

        &--div{
            padding-bottom: 26px;
            border-bottom: 1px solid $lightgray;
            user-select: none;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 11px;
            font-size: 16px;
            font-weight: 700;
            /* padding: 24px 0 24px 12px; */
            width: calc(100% - 16px);
            padding: 26px 0;

            &.clicked{
                color: $green;
            }
        }
        .tree__title{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 16px;
            font-weight: 700;
            gap: 11px;
            padding-left: 12px;
            cursor: pointer;
        }
    }
    &__code{
        padding-left: 12px;
        font-weight: 400;
        font-size: 15px;
        color: rgba($darkgray, .7);
        cursor: default;
    }
    &__units-list{
        min-width: 200px;
        height: fit-content;
        margin-right: 16px;
        @include flex-column;
        align-items: flex-start;
        gap: 12px;
        //border-bottom: 1px solid $lightgray;
        padding-bottom: 6px;
        background: $whitegray;
        .unit{
            padding: 12px 0;
            width: 100%;
            @include flex-column;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.07);
            &:first-child{
                padding: 16px 12px;
            }
            &--selected{
                .unit__name{
                    font-weight: 700;
                }
            }
            &__name{
                width: 100%;
                display: flex;
                font-weight: 500;
                justify-content: space-between;
                font-size: 13px;
                color: $black;
                padding: 0 12px;
                cursor: pointer;
                i{
                    line-height: 18px;
                }
            } 
            &__modules-list{
                width: 100%;
                margin-top: 12px;
                @include flex-column;
                align-items: flex-start;
                &__module{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 13px;
                    padding: 10px 12px;
                    color: $black;
                    cursor: pointer;
                    .material-icons{
                        font-size: 20px;
                    }
                    &--selected{
                        background-color: rgba(map-get($primary, onMediumEmphasis), 0.2);
                        span{
                            color: $green;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
    &__content{
        padding: 16px 24px 28px 24px;
        width: 100%;
        max-width: 73%;
        //flex-grow: 1;
        //padding: 16px;
        background: #fff;
        border-radius: 8px;
        color: $black;
        @media screen and (max-width: 1000px){
            padding: 16px 8px;
            max-width: 100%;
        }
        &__intro {
            display: flex;
            flex-direction: column;
            gap: 24px;

            &__header {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                color: #7d7d7d;
                font-size: 12px;

                &--name {
                    color: $green;
                    font-weight: 700;
                    font-size: 24px;
                    margin-top: 12px;
                }

                &--info {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    gap: 8px;
                    .pill {
                        width: 100%;
                        text-align: center;
                        padding: 8px 16px;
                        color: $green;
                        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
                        border-radius: 4px;
                    }
                    span{
                        font-weight: 600;
                        font-size: 12px;
                        color: $black;
                    }
                }
            }

            &__image{
                height: 300px;
                border-radius: 8px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }

            &__start-button{
                display: flex;
                // justify-content: center;
                align-items: center;
                gap: 8px;
                button{
                    display: flex;
                    gap: 8px;
                    padding: 8px 16px;
                    border-radius: 44px;
                    font-size: 16px;
                    font-weight: 600;
                    background: $green;
                    color: white;
                    // box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
                    &:disabled {
                        opacity: .5;
                        cursor: default;
                    }
                    .material-icons{
                        font-size: 18px;
                    }
                }
            }

            &__tabs {
                &__header {
                    display: flex;
                    gap: 16px;
                    // box-shadow: 0px 10px 8px 0px rgba(0, 0, 0, 0.10);
                    box-shadow: 2px 2px 8px 1px rgba(0, 0, 0, 0.10);
                    margin-bottom: 16px;
                    &__tab {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;
                        span {
                            font-weight: 600;
                            font-size: 15px;
                            color: $black;
                            padding: 16px;
                        }
                        &__line {
                            width: 100%;
                            height: 2px;
                            background: transparent;
                            &--selected {
                                background: $black;
                            }
                        }
                    }
                }
                &__body {
                    padding: 8px 0;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    &__about {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                        h4{
                            margin-top: 16px;
                            font-size: 18px;
                        }
                        &__description {
                            font-weight: 500;
                            font-size: 14px;
                            color: $black;
                        }
                        &__characteristics {
                            display: flex;
                            // flex-direction: column;
                            flex-wrap: wrap;
                            @media(max-width: 900px){
                                flex-direction: column;
                            }
                            &__item {
                                padding: 12px 0;
                                display: flex;
                                align-items: center;
                                gap: 16px;
                                font-weight: 600;
                                font-size: 14px;
                                color: $black;
                                // width: calc(50% - 16px);
                                width: calc(32% - 16px);
                                @media (max-width: 900px){
                                    width: 100%;
                                }

                                // icon color white backgorund $black and 100px border-radius, height 50px width 50px
                                i {
                                    color: #fff;
                                    background: $green;
                                    border-radius: 100%;
                                    height: 40px;
                                    width: 40px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                    &__reviews {
                        h4{
                            font-size: 18px;
                        }
                        .rating{
                            &__container{
                                padding: 12px 0;
                                display: flex;
                                align-items: center;
                                gap: 36px;
                            }
                            &__total{
                                min-width: 100px;
                                padding: 12px 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                gap: 6px;
                                strong{
                                    font-size: 64px;
                                    line-height: 64px;
                                    color: $green;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 700;
                                    color: $green;
                                }
                            }
                            &__detail{
                                width: 100%;
                                max-width: 700px;
                                display: flex;
                                flex-direction: column-reverse;
                                gap: 4px;
                                >div{
                                    display: flex;
                                    align-items: center;
                                    gap: 16px;
                                }
                                &__bar{
                                    width: 100%;
                                    height: 6px;
                                    background: #EAEDF4;
                                    border-radius: 50px;
                                    >div{
                                        height: 6px;
                                        background: $green;
                                        border-radius: 50px;
                                    }
                                }
                            }
                            .emptyState{
                                margin-top: 16px;
                            }
                            @media(max-width:500px){
                                &__container{
                                    flex-wrap: wrap;
                                    gap: 0;
                                }
                                &__total{
                                    width: 100%;
                                }
                            }

                        }
                        .comments{
                            padding-top: 16px;
                            .loader__container{
                                height: 180px;
                            }
                            h4{
                                margin-bottom: 18px;
                            }
                            &__empty{
                                font-size: 15px;
                            }
                            .comment{
                                padding: 16px 0;
                                display: flex;
                                gap: 18px;
                                &__picture{
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    position: relative;
                                    width: 54px;
                                    height: 54px;
                                    flex-shrink: 0;
                                    border-radius: 100%;
                                    overflow: hidden;
                                    font-size: 20px;
                                    font-weight: 700;
                                    background: #D9D9D9;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                                &__content{
                                    display: flex;
                                    flex-direction: column;
                                    gap: 6px;
                                    strong{
                                        font-size: 16px;
                                        font-weight: 700;
                                    }
                                    span{
                                        padding-top: 4px;
                                        font-size: 13px;
                                        font-weight: 400;
                                    }
                                }
                            }
                            .pagination{
                                width: 100%;
                                padding: 16px 16px 24px 16px;
                                display: flex;
                                justify-content: center;
                                gap: 24px;
                                .prev-next{
                                    @include icon-and-text-container;
                                    font-size: 15px;
                                    font-weight: 600;
                                    color: $green;
                                    line-height: 20px;
                                    &:disabled{
                                        cursor: default;
                                    }
                                    .material-icons{
                                        font-size: 20px;
                                    }
                                }
                                .page{
                                    font-size: 16px;
                                    font-weight: 400;
                                    span{
                                        font-weight: 700;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .quantities{
                display: flex;
                gap: 36px;

                div {                    
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 22px;
                    color: $black;
                    
                    i {
                        color: black;
                    }
                }
            }

            .button-continue {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 8px 16px;
                gap: 6px;
                width: fit-content;
                background: $green;
                color: white;
                box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
                border-radius: 44px;
                &:disabled {
                    opacity: .5;
                    cursor: default;
                }
                .material-icons{
                    font-size: 18px;
                }
            }
            .course-finished{
                padding: 14px;
                display: flex;
                align-items: stretch;
                >div{
                    display: flex;
                    flex-direction: column;
                    &:first-child{
                        width: fit-content;
                        .material-icons{
                            padding-right: 6px;
                        }
                    }
                    &:last-child{
                        flex-grow: 1;
                        gap: 12px;
                        font-size: 14px;
                    }
                }
                &__title{
                    padding-top: 2px;
                    font-weight: 700;
                }
                &__info{
                    font-weight: 500;
                }
                background-color: map-get($primary, onMediumEmphasis);
                &__title,.material-icons{
                    color: $green;
                }
                &--red{
                    background: rgba(255, 189, 176, 0.5);
                    .course-finished__title,.material-icons{
                        color: map-get($secondary, 500);
                    }
                }
            }
            .btn-download-certificate{
                width: fit-content;
                padding: 8px 16px;
                border-radius: 44px;
                font-size: 16px;
                font-weight: 600;
                border: 1px solid $green;
                color: $green;
                position: relative;
                height: 50px;
                background-image: none;
                outline: none;
                background-color: inherit;
                cursor: pointer;
                transition: all 0.2s ease-out;
                &:active::after {
                    opacity: 0.3;
                }
            }
        }
    }
}

.btn-download-certificate.loading::after {
    width: 40px;
    border-radius: 100%;
}

.loading {
    border-radius: 50px;
    width: 50px !important;
}


.modal{
    
    &__content{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;
        max-width: 691px;
        @media (max-width:980px) {
            width: 100%;        
        }
        >div{
            width: 100%;
        }
    }
    &__title{
        font-weight: 700;
        font-size: 18px;
        margin-bottom: 12px;
    }
}


/* MOBILE */
.btn-show-tree{
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    //align-items: center;
    gap: 8px;
    >span{
        color: $black;
        font-weight: 600;
        font-size: 13px;
    }
    button{
        width: fit-content;
        padding: 10px 8px;
        display: flex;
        align-items: center;
        gap: 10px;

        //width: 197px;
        //height: 44px;

        background: #FFFFFF;

        border: 1px solid $green;
        border-radius: 8px;
        color: $black;
        font-weight: 600;
        font-size: 13px;

    }
}

.material-icons.green{
    color: $green;
}

.course__tree.mobile{
    background: #F5F5F5;
    position: absolute;
    top: 0px;
    left: 0;
    width: 100vw;
    max-width: 100vw;
    height: 100%;
    //height: fit-content;
    min-height: 100vh;
    overflow-y: auto;
    z-index: 3000;
    padding: 0px 16px;
    .back{
        width: fit-content;
        display: flex;
        align-items: center;
        color: $black;
        padding-bottom: 8px;
        cursor: pointer;
    }
    .unit__name{
        padding: 8px 12px;
    }
    .module__name{
        font-size: 16px;
        @media screen and (max-width: $bpSmall){
         font-size: 12px;   
        }
    }
    .course__units-list{
        position: relative;
        top: 0px;
        padding-top: 0;
    }
}

.tutor-report--container{
    margin-top: 12px;
    margin-bottom: -12px;
    padding: 12px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    gap: 16px;
    background-color: #F5F5F5;
    position: sticky;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: #fff;
    border-top: 2px solid #eee;
    z-index: 99;
    .tutor-report{
        font-size: 16px;
        font-weight: 600;
        background: #009696;
        color: #fff;
        padding: 11px 25px;
        border-radius: 99px;
    }
}

@media screen and (max-width: 1000px){
    .course__content__intro__header--name{
        font-size: 20px
    }
}

.spinner {
	display: block;
	width: 34px;
	height: 34px;
	position: absolute;
	top: 8px;
	left: calc(50% - 17px);
	background: transparent;
	box-sizing: border-box;
	border-top: 4px solid $green;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-bottom: 4px solid transparent;
	border-radius: 100%;
	animation: spin 0.6s ease-out infinite;
}
@keyframes spin {
	100% {transform: rotate(360deg)}
}

.modal-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px 0;

    i {
        font-size: 48px;
        color: $green;
    }

    .modal__title {
        margin: 0;
    }

    .modal-text-content__content {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .btn-change-password {
        padding: 16px 24px;
        border-radius: 44px;
        font-size: 16px;
        font-weight: 600;
        background: $green;
        color: white;
        cursor: pointer;
        transition: all 0.2s ease-out;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        
        i {
            font-size: 18px;
            color: white;
        }
        &:disabled {
            opacity: .5;
            cursor: default;
        }
    }

    .btn-skip {
        font-size: 16px;
        font-weight: 600;
        color: $green;
    }
    .buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        button{
            padding: 10px 16px;
            border-radius: 44px;
            font-size: 16px;
            font-weight: 600;

            &.confirm {
                background: $green;
                color: #fff;
            }

            &:disabled{
                opacity: .5;
            }
        }
    }
}

.modal-change-password {
   .modal-change-password__content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        text-align: center;

        &__logo {
            width: 72px;
            margin: auto;    
        }

        &__instruction {
            font-size: 12px;
            font-weight: 400;
            // color: $black;

            &--red {
                color: $red;
            }
        }

        h3 {
            font-size: 24px;
            font-weight: 700;
            text-align: center;
        }

        p {
            font-size: 20px;
            font-weight: 600;
            text-align: center;

            &.modal-change-password__content__terms {
                font-size: 11px;
                font-weight: 400;
                text-align: center;
                max-width: 350px;
                margin: auto;
            }

            a {
                color: $green;
            }
        }

        &__fields {
            max-width: 350px;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .login-error {
            i {
                color: $red;
                font-size: 23px!important;
            }
        }
    }
}

.modal-email-sent {
    .modal-email-sent__content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        text-align: center;

        i {
            font-size: 32px;
            color: $green;
        }

        h3 {
            font-size: 22px;
            font-weight: 700;
            color: $green;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 600;
            text-align: center;

            small {
                font-size: 14px;
                font-weight: 400;
            }
        }

        .btn-entendido {
            padding: 16px 24px;
            border-radius: 44px;
            font-size: 16px;
            font-weight: 600;
            background: $green;
            color: white;
            cursor: pointer;
            transition: all 0.2s ease-out;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;

            width: 100%;
            
            i {
                font-size: 18px;
                color: white;
            }
            &:disabled {
                opacity: .5;
                cursor: default;
            }
        }

        .btn-skip {
            font-size: 16px;
            font-weight: 600;
            color: $green;
        }
    }
}
</style>

<style lang="scss">
@import '@/styles/main.scss';

.course__container .modal-content-container {
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background-color: transparent;
        margin: 4px 0;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
    }
}
.course__container .modal__container .modal__inner {
    width: 100%;
    max-width: 900px;
}
.course__container .preInscription {
    height: auto;
    align-items: stretch;
}
.course__container .preInscription__image {
    height: unset;
}
.course__container .preInscription__container {
    height: 100%;
}

// .modal-change-password .modal__inner {
.course__container .modal-change-password .modal__container .modal__inner {
    // width: auto!important;
    max-width: 544px;
    padding: 16px 32px;
}




</style>